<template>
  <b-row class="container-tabs ml-0 mr-0">
    <b-col col lg="4" md="4" sm="4" class="mobileGrid" :class="border1">
      <div class="tab-title" :class="tabTitle1">
        <span class="d-sm-block d-none"
          ><div class="tab-number" :class="tabNumber1">1</div>
          {{ $tc("message.stepperText", 0) }}</span
        >
        <div class="d-block d-sm-none tab-number" :class="tabNumber1">1</div>
        <span class="d-block d-sm-none" :class="tabTitle1">{{
          $tc("message.MobileStepperText", 0)
        }}</span>
      </div>
    </b-col>
    <b-col col lg="4" md="4" sm="4" class="mobileGrid" :class="border2">
      <div class="tab-title" :class="tabTitle2">
        <span class="d-sm-block d-none"
          ><div class="tab-number" :class="tabNumber2">2</div>
          {{ $tc("message.stepperText", 1) }}</span
        >
        <div class="d-block d-sm-none tab-number" :class="tabNumber2">2</div>
        <span class="d-block d-sm-none">{{
          $tc("message.MobileStepperText", 1)
        }}</span>
      </div>
    </b-col>
    <b-col col lg="4" md="4" sm="4" class="mobileGrid" :class="border3">
      <div class="tab-title" :class="tabTitle3">
        <span class="d-sm-block d-none"
          ><div class="tab-number" :class="tabNumber3">3</div>
          {{ $tc("message.stepperText", 2) }}</span
        >
        <div class="d-block d-sm-none tab-number" :class="tabNumber3">3</div>
        <span class="d-block d-sm-none">{{
          $tc("message.MobileStepperText", 2)
        }}</span>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    "tabTitle1",
    "tabTitle2",
    "tabTitle3",
    "tabNumber1",
    "tabNumber2",
    "tabNumber3",
    "border1",
    "border2",
    "border3",
  ],
  name: "tabs",
};
</script>

<style lang="scss" scoped>

.container-tabs {
  background-color: white;
  padding: 0;
}

  .container-tabs {
    padding: 12px 0 0 0;
  }

  .mobileGrid {
  padding: 1.4vh 0;
  border: 1px solid #e5e5e5;
}


.mobileGrid:first-child {
  border-top-left-radius: 5px;
}
.mobileGrid:last-child {
  border-top-right-radius: 5px;
}

.tab-title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #9f9f9f;
  width: 100%;
}

.tab-number {
  background-color: #c1c8cf;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  color: #fff;
  margin: 5px auto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  display: inline-block;
  margin-right: 8px;
}
.active {
  color: var(--primary-bg);
}

.active-number {
  background-color: var(--primary-bg);
}
@media (max-width: 600px) {

   .mobileGrid {
    padding: 0;
    padding-bottom: 10px;
    border: none;
  }

  .tab-title {
    font-size: 14px;
  }
  .tab-number {
    margin-right: auto;
  }
    .active-border {
    border-bottom: 2px solid var(--primary-bg);
  }

  .inactive-border {
    border-bottom: 2px solid rgba(229, 229, 229, 0.4);
  }
}
</style>